<template>
  <div class="select">
    <div class="wrapper">
      <div class="container">
        <div class="left">
          <div class="content">
            <back-action />
            <h1>Heb je ervaring met Europese samenwerking?</h1>
          </div>
        </div>
        <div class="right">
          <div class="content" id="main">
            <div class="inner">
              <div class="rows">
                <router-link to="/kleinschalige-partnerschappen" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">
                      <span class="title">Geen of weinig ervaring</span>
                      <span class="sub">Ik heb nog geen of weinig ervaring met Europese samenwerking en wil voor een periode van 6-24 maanden met minimaal twee andere landen samenwerken.</span>
                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
                <router-link to="/samenwerkingspartnerschappen" class="col">
                  <div class="col__rows">
                    <div class="col__rows--left">

                      <span class="title">Ja, ik heb ervaring</span>
                      <span class="sub">Ik heb ervaring met Europese samenwerking en wil voor een periode van 12-36 maanden met minimaal drie andere landen samenwerken.</span>

                    </div>
                    <div class="col__rows--right">
                      <button class="button">Maak keuze</button>
                    </div>
                  </div>
                </router-link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
